import React from "react";
import ToolbarComponent from "./Toolbar/Toolbar";
import PaginationComponent from "./Pagination/Pagination";
import { useShallowSelector } from "../../../hooks/useShallowSelector";
import RootState from "../../../redux/types/rootState";

export interface FooterProps {
  handleSendButtonClick: () => void;
  onPageChange: (event: React.ChangeEvent<unknown>, value: number) => void;
  classes: Record<string, string>;
}

const Footer: React.FC<FooterProps> = ({
  classes,
  onPageChange,
  handleSendButtonClick,
}) => {
  const bookingsResponse = useShallowSelector(
    (state: RootState) => state.bookings.bookingsResponse
  );

  const { results: apiBookings } = bookingsResponse || {};

  if (apiBookings)
    return (
      <>
        <PaginationComponent onPageChange={onPageChange} classes={classes} />

        <ToolbarComponent
          handleSendButtonClick={handleSendButtonClick}
          classes={classes}
        />
      </>
    );
  return <></>;
};

export default Footer;
